// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3715":"list","9702":"story"}[chunkId] || chunkId) + "-" + {"2217":"de238d3dc94010bae3fd","3715":"545c79e7053049c5208c","5737":"15a0d08e772783426cef","9702":"f24f92f9dd21e621a9b4"}[chunkId] + ".css";
};